export default __webpack_public_path__ + "static/media/project4_mockup.c4e10e69.png";